import { render, staticRenderFns } from "./ConsultantCertificates.vue?vue&type=template&id=048cf50c&scoped=true"
import script from "./ConsultantCertificates.vue?vue&type=script&lang=js"
export * from "./ConsultantCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048cf50c",
  null
  
)

export default component.exports